import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesParameter = {
  namespaced: true,
  state: {
    data: null,
    loading: false
  },
  mutations: {
    readParameterSuccess(state, payload) {
      const data = payload.data
      state.data = {
        id: data.id,
        name: data.attributes.name,
        values: data.attributes.values.map(v => castAttributesForCamelCase(v))
      }
      state.loading = false
    },
    prepareConnect(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    }
  },
  actions: {
    readParameter({commit, rootState}) {
      commit('prepareConnect')

      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/parameters/' + rootState.route.params.parameter_id)
        .then(res => {
          commit('readParameterSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', {type: 'alert', message: err.response.data.errors[0].detail}, {root: true})
        })
    },
    createParameter({commit, rootState}, {payload}) {
      commit('prepareConnect')

      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/parameters', payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', {
            type: 'notice',
            message: i18n.t('messages.created', {value: i18n.t('models.parameter.modelName')})
          }, {root: true})
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', {type: 'alert', message: err.response.data.errors[0].detail}, {root: true})
          console.error(err)
          return false
        })
    },
    updateParameter({commit, rootState}, {payload}) {
      commit('prepareConnect')

      return axios
        .patch('/api/companies/' + rootState.route.params.company_uuid + '/parameters/' + rootState.route.params.parameter_id, payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', {
            type: 'notice',
            message: i18n.t('messages.updated', {value: i18n.t('models.parameter.modelName')})
          }, {root: true})
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', {type: 'alert', message: err.response.data.errors[0].detail}, {root: true})
          console.error(err)
          return false
        })
    },
    deleteParameter({ commit, rootState }, id) {
      commit('prepareConnect')

      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/parameters/' + id)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.parameter.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    }
  }
}
